export default __webpack_public_path__ + "static/media/active user.f6b40b3b.png";